export function insertCss(url: string) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = url;

  document.head.appendChild(link);
}
